export default __webpack_public_path__ + "static/media/icoDel.c1b9920f.svg";